import React from 'react';
import { observer } from 'mobx-react';
import { Switch, Route, useLocation, useRouteMatch, Redirect } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import getRouteKey from 'utilities/getRouteKey';
import joinPath from 'utilities/joinPath';
import Page from 'components/Page';
import Container from 'components/sidebar/Container';
import Content from 'components/sidebar/Content';
import PageContainer from 'components/PageContainer';

import UnitTypeSidebar from './UnitTypeSidebar';
import Floorplan from './Floorplan';
import WalkThrough from './WalkThrough';
import RenderGallery from './RenderGallery';
import ColourSchemes from './ColourSchemes';
import Features from './Features';

const UnitType = observer(() => {
    const location = useLocation();
    const match = useRouteMatch();
    
    return (
        <Page>
            <Container>
                <UnitTypeSidebar />
                
                <Content>
                    <PageContainer>
                        <AnimatePresence>
                            <Switch location={location} key={getRouteKey(location, match)}>
                                {/* Redirect from parent page to Floorplan */}
                                <Route exact path={match.path}>
                                    <Redirect to={joinPath(match.url, 'floorplan')} />
                                </Route>
                                
                                <Route path={joinPath(match.path, 'floorplan')}>
                                    <Floorplan />
                                </Route>
                                
                                <Route path={joinPath(match.path, 'walk-through')}>
                                    <WalkThrough />
                                </Route>
                                
                                <Route path={joinPath(match.path, 'render-gallery')}>
                                    <RenderGallery />
                                </Route>
                                
                                <Route path={joinPath(match.path, 'colour-schemes')}>
                                    <ColourSchemes />
                                </Route>
                                
                                <Route path={joinPath(match.path, 'features')}>
                                    <Features />
                                </Route>
                            </Switch>
                        </AnimatePresence>
                    </PageContainer>
                </Content>
            </Container>
        </Page>
    );
});

export default UnitType;

